import { api } from '../../lib/api';

export const COUNT_STATUSES = [
  { value: 'Draft', label: 'Draft', tone: 'neutral' },
  { value: 'Posted', label: 'Posted', tone: 'success' },
  { value: 'Cancelled', label: 'Cancelled', tone: 'danger' },
];

export const countStatusMeta = (status) =>
  COUNT_STATUSES.find((s) => s.value === status) || { value: status, label: status, tone: 'neutral' };

export const COUNT_TYPES = [
  { value: 'Full', label: 'Full count' },
  { value: 'Cycle', label: 'Cycle count' },
];

export const countTypeLabel = (value) =>
  COUNT_TYPES.find((t) => t.value === value)?.label || value;

function toQuery(params) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const countsApi = {
  list: (params = {}) => api.get(`/stock-counts${toQuery(params)}`),
  get: (id) => api.get(`/stock-counts/${id}`),
  create: (payload) => api.post('/stock-counts', payload),
  saveCounts: (id, payload) => api.put(`/stock-counts/${id}/counts`, payload),
  post: (id) => api.post(`/stock-counts/${id}/post`),
  cancel: (id, reason) => api.post(`/stock-counts/${id}/cancel`, { reason: reason || null }),
};
